import { NodeUtils, EditorUtils } from '@ssml-editor/vue';
import { SUB_TYPE } from './constant.js';

const subPlugin = (editor) => {
  const { isInline, isVoid, insertNode } = editor;
  const newEditor = editor;
  newEditor.isInline = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === SUB_TYPE) return true;
    return isInline(element);
  };
  newEditor.isVoid = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === SUB_TYPE) return false;
    return isVoid(element);
  };
  newEditor.insertNode = (node) => {
    const type = NodeUtils.getNodeType(node);
    if (type === SUB_TYPE && newEditor.selection) {
      EditorUtils.insertSpace(newEditor, newEditor.selection);
    }
    insertNode(node);
  };
  return newEditor;
};

export { subPlugin };
//# sourceMappingURL=plugin.js.map
